export default __webpack_public_path__ + "static/media/coin-master@2x.eaf5eeca.webp";